"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@uirouter/angular");
const sso_config_component_1 = require("./ssoConfigFeature/sso-config.component");
exports.states = [
    {
        name: "ssoConfigFeature",
        url: "/customer-care/sso-config",
        component: sso_config_component_1.SsoConfigComponent,
    }
];
